import React from "react";
import Farm from './components/Farm';
import Logo from './components/Logo';
import "./styles.css";

export default function App() {
  return (
    <div className="App">
        <Logo width={400}/>
        <Farm width={400} height={267} />
    </div>
  );
}
